import { ChevronLeft, ChevronRight } from "lucide-react";

type TablePagerProps = {
  page: number;
  pageCount: number;
  totalRows: number;
  onPrevious: () => void;
  onNext: () => void;
};

export const TABLE_PAGE_SIZE = 10;

export function TablePager({
  page,
  pageCount,
  totalRows,
  onPrevious,
  onNext,
}: TablePagerProps) {
  if (totalRows <= TABLE_PAGE_SIZE) return null;

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 border-t border-slate-200 px-4 py-3 text-sm">
      <p className="font-medium text-slate-500">
        Page {page} of {pageCount}
      </p>
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={onPrevious}
          disabled={page === 1}
          className="inline-flex items-center gap-1 rounded-lg border border-slate-200 px-3 py-2 font-semibold text-slate-700 disabled:cursor-not-allowed disabled:opacity-45"
        >
          <ChevronLeft size={16} />
          Previous
        </button>
        <button
          type="button"
          onClick={onNext}
          disabled={page === pageCount}
          className="inline-flex items-center gap-1 rounded-lg border border-slate-200 px-3 py-2 font-semibold text-slate-700 disabled:cursor-not-allowed disabled:opacity-45"
        >
          Next
          <ChevronRight size={16} />
        </button>
      </div>
    </div>
  );
}
